import { apiClientTodoTd } from "./config";

/**
 * Get task categories list TodoTD
 * @param { organizationId } queryParams
 * @param {function} successCallback
 * @param {function} errorCallback
 * @returns
 */
export const getTaskCategories = async (
	queryParams = {},
	successCallback = false,
	errorCallback = false
) => {
	const { organizationId, ...params } = queryParams;

	try {
		const response = await apiClientTodoTd.get(`/task-categories`, {
			params,
			headers: { "X-Organization-Id": organizationId },
		});
		if (successCallback) successCallback(response.data);
		return response.data;
	} catch (error) {
		if (errorCallback) errorCallback(error.response);
		return error;
	}
};
